<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>

    .hkec-button{
      min-width: 88px;
      margin: 0 16px;
      border-radius: 5px;
      font-size: 16px;
      }
    .hkec-pagination{
      display:flex;
      padding-top:16px;
    }
    #qrcode img{
      padding: 10px;
      background-color: white
    }

    .hkec-hidden{
      display:none;
      visibility:hidden
    }
</style>


